module.exports = __webpack_public_path__ + "images/139_320.jpg";